import { defineMessages } from "react-intl";

export const messages = defineMessages({
    fastshiftMigrationStatusTableTitle: {
        id: "fastshift.migration-status-table.title",
        defaultMessage: "Migration Progress",
        description: "Title for the FastShift migration status table"
    },
    fastshiftMigrationStatusTableTitleForUnassociatedTickets: {
        id: "fastshift.migration-status-table.title-unassociated-tickets",
        defaultMessage: "Tickets from Other Cloud Orgs",
        description:
            "Title for the FastShift migration status table - shown for the case we're displaying tickets for orgs that the customer is not an admin of"
    },
    fastshiftMigrationStatusTableSourceColumnTitle: {
        id: "fastshift.migration-status-table.source-column-title",
        defaultMessage: "Source",
        description:
            "Column title on the migration status table to indicate the source instance for a migration"
    },
    fastshiftMigrationStatusTableDestinationColumnTitle: {
        id: "fastshift.migration-status-table.destination-column-title",
        defaultMessage: "Destination",
        description:
            "Column title on the migration status table to indicate the destination instance for a migration"
    },
    fastshiftMigrationStatusTablePhaseColumnTitle: {
        id: "fastshift.migration-status-table.phase-column-title",
        defaultMessage: "Phase",
        description:
            "Column title on the migration status table to indicate the phase of a migration"
    },
    fastshiftMigrationStatusTableStatusColumnTitle: {
        id: "fastshift.migration-status-table.status-column-title",
        defaultMessage: "Status",
        description:
            "Column title on the migration status table to indicate the status of a migration"
    },
    fastshiftMigrationStatusTableTicketColumnTitle: {
        id: "fastshift.migration-status-table.ticket-column-title",
        defaultMessage: "Ticket",
        description:
            "Column title on the migration status table to indicate the ticket ID of a migration"
    },
    fastshiftMigrationStatusTablePageCount: {
        id: "fastshift.migration-status-table.page-count",
        defaultMessage:
            "Showing <strong>{numberOfTicketsToShow}</strong> of <strong>{totalTickets}</strong>",
        description: "Table page count for the FastShift migration status table"
    },
    fastshiftMigrationStatusTableShowMoreFooterButton: {
        id: "fastshift.migration-status-table.show-more-footer-button",
        defaultMessage: "Show more",
        description:
            "Footer button for the FastShift migration status table to show more rows"
    },
    fastshiftMigrationStatusTableEmptyTitle: {
        id: "fastshift.migration-status-table.empty-title",
        defaultMessage: "No data",
        description:
            "Empty title for the FastShift migration status table when there are no tickets"
    },
    fastshiftMigrationStatusTableEmptyDescription: {
        id: "fastshift.migration-status-table.empty-description",
        defaultMessage: "No data to show",
        description:
            "Empty table description for the FastShift migration status table when there are no tickets"
    },
    fastshiftMigrationStatusTableErrorTitle: {
        id: "fastshift.migration-status-table.error-title",
        defaultMessage: "Something went wrong",
        description:
            "Error title for the FastShift migration status table when tickets fail to load"
    },
    fastshiftMigrationStatusTableErrorDescription: {
        id: "fastshift.migration-status-table.error-description",
        defaultMessage:
            "We couldn’t retrieve the data about your migration progress.",
        description:
            "Error description for the FastShift migration status table when tickets fail to load"
    },
    fastshiftMigrationStatusTableErrorRefreshButton: {
        id: "fastshift.migration-status-table.error-refresh-button",
        defaultMessage: "Refresh",
        description:
            "Refresh button text for the FastShift migration status table when tickets fail to load"
    },
    fastshiftMigrationStatusTableNoSourcePresent: {
        id: "fastshift.migration-status-table.no-source-present",
        defaultMessage: "No source present",
        description:
            "Message shown when there is no source present for a move ticket in the FastShift migration status table"
    }
});
